import { useState } from "react";
import { subscribe } from "@/lib/api";
import { toast } from "sonner";
import { ArrowRight } from "lucide-react";

/** Compact horizontal newsletter band — sits right below the hero. */
export default function NewsletterBand() {
  const [f, setF] = useState({ name: "", email: "", city_state: "" });
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setF((s) => ({ ...s, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (!f.email) return;
    setLoading(true);
    try {
      await subscribe({
        name: f.name || null,
        email: f.email,
        city_state: f.city_state || null,
      });
      toast.success("Bem-vindo à comunidade ROTTA!", { description: "Você receberá nossas próximas rotas em primeira mão." });
      setF({ name: "", email: "", city_state: "" });
    } catch {
      toast.error("Não conseguimos cadastrar agora. Tente novamente.");
    } finally { setLoading(false); }
  };

  return (
    <section className="relative border-y border-[#1f1f1f] bg-[#0d0d0d]" data-testid="newsletter-band">
      <div className="container-rotta py-12 md:py-10 lg:py-6">
        <form onSubmit={submit} className="flex flex-col lg:flex-row lg:items-center gap-7 lg:gap-4" data-testid="newsletter-band-form">
          <div className="shrink-0 lg:pr-6 lg:border-r border-[#242424]">
            <div className="text-[10px] tracking-[0.3em] uppercase text-[#C6A762]">Comunidade ROTTA</div>
            <div className="font-display text-2xl lg:text-xl text-white leading-tight mt-2 lg:mt-1">Entre para a tribo da estrada</div>
          </div>
          <div className="flex-1 grid grid-cols-1 md:grid-cols-3 gap-4 lg:gap-3">
            <input data-testid="band-name" className="input-rotta py-5 lg:py-3 text-base lg:text-sm" placeholder="Nome" value={f.name} onChange={set("name")} />
            <input data-testid="band-email" type="email" required className="input-rotta py-5 lg:py-3 text-base lg:text-sm" placeholder="E-mail" value={f.email} onChange={set("email")} />
            <input data-testid="band-city-state" className="input-rotta py-5 lg:py-3 text-base lg:text-sm" placeholder="Cidade/Estado — ex: Belo Horizonte/MG" value={f.city_state} onChange={set("city_state")} />
          </div>
          <button data-testid="band-submit" disabled={loading} className="btn-gold shrink-0 px-6 py-5 lg:py-3.5 rounded-full text-xs inline-flex items-center justify-center gap-2 disabled:opacity-60">
            {loading ? "Enviando…" : "Entrar para a comunidade"} <ArrowRight size={14} />
          </button>
        </form>
      </div>
    </section>
  );
}
